// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from "vue";
import VueGtag from "vue-gtag";

export default ({ isDev, app }) => {
  if (!isDev) {
    Vue.use(
      VueGtag,
      {
        config: { id: process.env.NUXT_ENV_GA_ID },
      },
      app.router
    );
  } else {
    // eslint-disable-next-line no-console
    console.log("Skipping GA in development");
  }
};
